<template>
  <div>
    <table class="table table-xs table-hover">
      <thead>
      <tr>
        <th colspan="3" class="text-danger">Akbank Banka Entegrasyonu
          <button
            @click="this.Ekle"
            class="el-button TableBtn el-button--success el-button--mini float-right">Banka Hesabı Ekle
          </button>
        </th>
      </tr>
      <tr>
        <th>Tanım</th>
        <th>Bina</th>
        <th width="50">İşlem</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="b in Liste">
        <td>{{b.Tanim}}</td>
        <td>{{b.Bina}}</td>
        <td>
          <el-tooltip class="item" effect="dark" content="Düzenle"
                      placement="top-start">
            <a href="#" @click="Duzenle(b)" class="text-info mr-1"> <i
              class="feather-edit-2"></i></a>
          </el-tooltip>
          <el-tooltip class="item" effect="dark"
                      content="Sil"
                      placement="top-start">
            <a href="#" @click="SilOnay(b.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
          </el-tooltip>


        </td>
      </tr>
      </tbody>
    </table>
    <el-form v-if="FormDisplay" class="BilgiForm" :rules="FormHata" :model="Form"
             @submit.prevent.native="Submit"
             ref="Entegrasyon">
      <h2>Akbank Entegrasyon Ekle <a @click="FormDisplay=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Site / Bina" prop="Bina_id">
            <el-select v-model="Form.Bina_id" filterable clearable>
              <el-option-group
                label="Site Listesi">
                <el-option
                  v-for="item in Siteler"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
                </el-option>
              </el-option-group>
              <el-option-group
                label="Bina Listesi">
                <el-option
                  v-for="item in Binalar"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Tanım" prop="Tanim">
            <el-input type="input" v-model="Form.Tanim">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Kullanıcı Adı" prop="username">
            <el-input type="input" v-model="Form.username">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Şifre" prop="pass">
            <el-input type="input" v-model="Form.pass">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <button type="button" @click="Submit" v-if="!lo"
              class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">KAYDET
      </button>
    </el-form>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        lo: false,
        Yetki: false,
        FormDisplay: false,
        Liste: [],
        Binalar: [],
        Siteler: [],
        Form: {
          id: null,
          Tanim: null,
          Bina_id: null,
          username: null,
          pass: null,
        },
        FormHata: {
          Tanim: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          username: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          pass: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
        }

      }
    },
    methods: {
      Submit() {
        this.$refs['Entegrasyon'].validate((valid) => {
            if (valid) {
              this.$message.info("Bilgiler Banka tarafından kontrol ediliyor");
              this.lo = true;
              if (this.Form.id) {
                // DÜZENLES
                this.$store.dispatch("Put", {
                  ...this.Form,
                  path: 'entegrasyon/banka/' + this.Form.id
                })
                  .then(response => {
                    this.lo = false;
                    if (response.Durum == "OK") {
                      this.SayfaYukle();
                      this.$message.success(response.Mesaj);
                      this.Form = {
                        id: null,
                        Tanim: null,
                        Bina_id: null,
                        username: null,
                        pass: null,
                      }
                    } else {
                      this.$message.error(response.Mesaj);
                      this.hata = response.Hata;
                    }
                  })
              } else {
                this.Form.Banka = 'akbank';
                // EKLE
                this.$store.dispatch("Post", {
                  ...this.Form,
                  path: 'entegrasyon/banka'
                })
                  .then(response => {
                    this.lo = false;
                    if (response.Durum == "OK") {
                      this.SayfaYukle();
                      this.$message.success(response.Mesaj);
                      this.Form = {
                        id: null,
                        Tanim: null,
                        Bina_id: null,
                        username: null,
                        pass: null,
                      }
                    } else {
                      this.$message.error(response.Mesaj);
                      this.hata = response.Hata;
                    }
                  })

              }
            }
          }
        );
      },
      SayfaYukle() {

        this.$store.dispatch("Get", {path: 'entegrasyon/banka/akbank'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.FormDisplay = false;
              this.Form = {
                id: null,
                Tanim: null,
                Bina_id: null,
                username: null,
                pass: null,
              }
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

        this.Yetki = this.$store.getters.Yetki.entegrasyon == 2 ? true : false;
      },
      Ekle() {
        this.FormDisplay = true;
        this.Form = {
          id: null,
          Tanim: null,
          Bina_id: null,
          username: null,
          pass: null,
        }
      },
      Duzenle(Veri) {
        this.FormDisplay = true;
        this.Form = {
          id: Veri.id,
          Bina_id: Veri.Bina_id,
          Tanim: Veri.Tanim,
          Banka: Veri.Banka,
          username: Veri.username,
          pass: Veri.pass,
        }
      },

      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {path: 'entegrasyon/banka/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },

    },
    created() {
      this.SayfaYukle();
      this.$store.dispatch("Get", {path: 'yonetim/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'yonetim/site'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Entegrasyon/Bankalar/akbank.vue